// Show and hide persistent CTA based on scroll position
var persistentCta = document.getElementById("persistent-cta");
if (persistentCta) {
  var persistentCtaScrollTop = persistentCta.offsetTop;  
  var lastScrollTop = 0;
  window.addEventListener("scroll", function(){  
    var browserZoomLevel = Math.round(window.devicePixelRatio * 100);
    var st = window.pageYOffset || document.documentElement.scrollTop;
    var sb = window.innerHeight + (window.scrollY || window.pageYOffset);
    if(browserZoomLevel <= 200) {
      // if (st > lastScrollTop && st > 200 && sb < (document.body.offsetHeight - 400)){
      if (st > lastScrollTop && st > 200 && st < persistentCtaScrollTop){
          persistentCta.className = 'persistent-cta active'; 
      } else {
        persistentCta.className = 'persistent-cta';
      }
    }
    lastScrollTop = st;
  }, false);
}